import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { Dashboard4Component } from "./dashboard4.component";

// Chart.js Angular 2 Directive by Valor Software (npm)
import { ChartsModule } from 'ng2-charts/ng2-charts';

import { FlotModule } from '../../components/charts/flotChart';
import { IboxtoolsModule } from '../../components/common/iboxtools/iboxtools.module';
import { PeityModule } from '../../components/charts/peity';
import { SparklineModule } from '../../components/charts/sparkline';
import { JVectorMapModule } from '../../components/map/jvectorMap';
import { NgxPaginationModule } from "ngx-pagination/dist/ngx-pagination";
import { StoreStatusModule } from "./store-status/store-status.module";
import { LineGraphModule } from "./line-graph/line-graph.module";
import { DashboardTableModule } from "./dashboard-table/dashboard-table.module";
import { BillsTableModule } from "./bills-table/bills-table.module";
import { FormsModule } from '@angular/forms';
import { JiraDashboardComponent } from "./jira-dashboard.component";
import { JiraTableComponent } from "./jira-table.component";
import { AdminCommonModule } from "../admin/admin-common.module";

@NgModule({
    declarations: [
        Dashboard4Component,
        JiraDashboardComponent,
        JiraTableComponent
    ],
    imports: [
        BrowserModule,
        ChartsModule,
        FlotModule,
        IboxtoolsModule,
        PeityModule,
        SparklineModule,
        JVectorMapModule,
        NgxPaginationModule,
        StoreStatusModule,
        LineGraphModule,
        DashboardTableModule,
        BillsTableModule,
        AdminCommonModule
    ]
})

export class DashboardsModule { }



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/dashboards.module.ts